<template>
  <div class="SpUploadGroup flex">
    <input ref="fileUploadRef" :disabled="disabled" :name="name" multiple :accept="accept" hidden type="file" @change="checkFile">
    <sp-upload v-for="(file,index) in fileList" :key="index"
               :width="width"
               :height="height"
               :disabled="disabled"
               :file="file" :accept="accept" class="mg-b-10 mg-r-20"
               :upload-after-select="uploadAfterSelect"
               @after-select="afterSelect(index,$event)"
               @delete="()=>deleteFile(index)" />
    <sp-upload v-if="fileList.length<maxCount && !disabled" :up-title="upTitle"
               :width="width" :height="height" @click="()=>fileUploadRef.click()" />
  </div>
</template>

<script type="text/ecmascript-6">
import spUpload from '@/components/common/SpUploadPreview'
import { ref, toRefs } from '@vue/reactivity'
import { computed, provide, watch } from 'vue'
import { include } from '@/utils/check'
import CryptoJS from 'crypto-js'
import { checkFileUpdated, uploadFile, removeFile } from '@/request/APIs/file'
import { toRef } from '@vue/runtime-core'
import useForm from '@/hooks/useForm'

export default {
  name: 'SpUploadGroup',

  nameSpace: 'SpUploadGroup',

  components: {
    spUpload
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    maxCount: {
      type: Number,
      default: 10
    },

    accept: {
      type: String,
      default: 'image/*'// 可选 audio/* | video/* | image/* | MIME_type
    },

    uploadAfterSelect: { // 选择后自动上传
      type: Boolean,
      default: true
    },

    defaultFiles: {
      type: Array,
      default: () => []
    },

    fileType: { // 文件类型，后端需要
      type: String,
      default: ''
    },

    name: { // html-name
      type: String,
      default: ''
    },

    businessId: { // 主数据id，后端需要
      type: String,
      default: ''
    },

    splitter1: {
      type: Number,
      default: () => null
    },

    splitter2: {
      type: Number,
      default: () => null
    },

    splitter3: {
      type: Number,
      default: () => null
    },

    fileName: {
      type: String,
      default: ''
    },

    width: { // 宽度
      type: Number,
      default: 222
    },

    height: { // 高度
      type: Number,
      default: 280
    },

    upTitle: {
      type: String,
      default: ''
    }
  },

  emits: ['update:modelValue', 'afterSelect'],
  setup (props, ctx) {
    const fileUploadRef = ref(null)
    const fileList = ref([...(props.defaultFiles || [])])
    watch(() => props.defaultFiles, (nv) => {
      fileList.value = nv
    })
    // 监听businessid
    // watch(() => props.businessId, (nv) => {
    //   if (nv && props.uploadAfterSelect) {
    //     uploadAll()
    //   }
    // })
    const model = computed(() => {
      return {
        fileList,
        upload,
        uploadAll
      }
    })

    useForm(props.name ? toRef(props, 'name') : toRef(props, 'fileType'), 'file', model)

    const afterSelect = (index, file) => {
      fileList.value.push(file)
    }
    // 检查文件
    const checkFile = async () => {
      const files = fileUploadRef.value.files

      if (files.length > 0) {
        const restCount = props.maxCount - fileList.value.length
        for (let i = 0; i < restCount && i < files.length; i++) {
          const file = files[i]
          // console.log(file)
          const url = window.URL.createObjectURL(file)
          const fileLocal = { name: file.name, url: url, file: file }
          if (file.type.includes('image')) {
            fileLocal.type = 'img'
          } else if (include(file.type, 'pdf', 'text')) {
            fileLocal.type = 'pdf'
          } else {
            fileLocal.type = 'other'
          }
          const reader = new FileReader()
          reader.readAsArrayBuffer(file)
          await new Promise((resolve, reject) => {
            reader.onload = function () {
              const wordArray = CryptoJS.lib.WordArray.create(reader.result)
              const hash = CryptoJS.SHA256(wordArray).toString()
              fileLocal.hash = hash
              resolve()
            }
          })
          fileList.value.push(fileLocal)
          if (props.uploadAfterSelect) {
            uploadAll()
          }
        }
      }
    }
    // 删除文件
    const deleteFile = (index) => {
      if (!fileList.value[index]?.id) {
        fileList.value.splice(index, 1)
      } else {
        removeFile({ type: props.fileType, id: props.businessId, fid: fileList.value[index].id }).then(res => {
          fileList.value.splice(index, 1)
        })
      }
    }

    const upload = (file) => {
      ctx.emit('afterSelect', fileList, props.fileName)
      if (!props.businessId || !props.fileType) {
        console.error('businessId or fileType required!', props.businessId, props.fileType)
        return null
      }
      return new Promise((resolve, reject) => {
        if (file.file && file.hash && file.status !== 'uploaded' && file.status !== 'uploading') {
          checkFileUpdated({
            type: props.fileType,
            id: props.businessId,
            hash: file.hash,
            splitter1: props.splitter1,
            splitter2: props.splitter2,
            splitter3: props.splitter3
          }).then(res => {
            if (!res.updated) {
              file.status = 'uploading'
              uploadFile({
                type: props.fileType,
                id: props.businessId,
                upload: file.file,
                splitter1: props.splitter1,
                splitter2: props.splitter2,
                splitter3: props.splitter3
              }).then((res) => {
                // console.log(res)
                if (res.code === 1) {
                  file.status = 'uploaded'
                  resolve()
                }
              }).catch(err => {
                console.log(err)
                file.status = 'failed'
                reject(err)
              })
            } else {
              file.status = 'uploaded'
              resolve()
            }
          })
        } else {
          resolve()
        }
      }).then(res => {
        console.log(file.name, 'uploaded')
      })
    }

    const uploadAll = () => {
      return Promise.all(fileList.value.map(file => upload(file)))
      // fileList.value.forEach(file => {
      //   console.log('group 上传')
      //   upload(file)
      // })
    }
    return {
      fileUploadRef,
      fileList,
      afterSelect,
      uploadAll,
      deleteFile,
      checkFile
    }
  }

}
</script>

<style scoped lang="less">
.SpUploadGroup {
  //css、less
}
</style>
